import { useState } from "react";

const OPTIONS = [
  ["good", "Good"],
  ["cosmetic", "Cosmetic"],
  ["repair", "Repair"],
  ["replace", "Replace"],
  ["na", "N/A"],
];
const PRECONDITION_OPTIONS = [["good", "Cleared"], ["replace", "Appliances on site"]];

export const ItemRow = ({ roomKey, item, finding, onSet }) => {
  const [note, setNote] = useState(finding?.note || "");
  const current = finding?.condition;
  const tid = `insp-item-${roomKey}-${item.key.replace(":", "-")}`;
  const isLifeSafety = item.category === "life_safety";
  const isPre = item.category === "precondition";
  const opts = isPre ? PRECONDITION_OPTIONS : OPTIONS;

  return (
    <div className={`insp-item ${current ? "insp-item--set" : ""}`} data-testid={tid}>
      <div className="insp-item__label">
        {item.label}
        {isLifeSafety && <span className="insp-ls">Life-safety</span>}
        {item.category === "structural" && <span className="insp-struct">Structural</span>}
        {item.category === "system" && <span className="insp-sys">System</span>}
        {isPre && <span className="insp-pre" data-testid={`${tid}-precondition-badge`}>Pre-condition</span>}
        {item.responsibility === "client" && <span className="insp-client" data-testid={`${tid}-client-badge`}>Client scope · document only</span>}
      </div>
      {item.code_ref && <div className="insp-item__ref">{item.code_ref}</div>}
      <div className="insp-cond" role="radiogroup">
        {opts.map(([k, l]) => (
          <button key={k} type="button" className={`insp-cond__btn insp-cond__btn--${k} ${current === k ? "on" : ""}`}
                  onClick={() => onSet(roomKey, item.key, k, note)} data-testid={`${tid}-${k}`}>
            {l}
          </button>
        ))}
      </div>
      {current && !["good", "na"].includes(current) && (
        <input className="insp-note" placeholder="Note (what / where / qty)" value={note}
               onChange={(e) => setNote(e.target.value)} onBlur={() => note !== (finding?.note || "") && onSet(roomKey, item.key, current, note)}
               data-testid={`${tid}-note`} />
      )}
    </div>
  );
};
